import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Lo compré en marzo y desde ahí no improvisé más. Las secuencias del Tomo 2 las apliqué tal cual con mis alumnos y les encantó la fluidez.',
  name: 'Carolina M.',
  role: 'Profesora de Hatha Yoga',
  city: 'Córdoba',
  initial: 'CM',
  color: 'bg-rose-500'
}, {
  quote: 'Doy clases hace 14 años y nunca tuve un material tan completo. Las planificaciones me salvaron el año entero. Llego al estudio y sé exactamente qué hacer.',
  name: 'Mariano L.',
  role: 'Instructor de Vinyasa',
  city: 'Buenos Aires',
  initial: 'ML',
  color: 'bg-brand-500'
}, {
  quote: 'Pensé que era otro PDF más. Me equivoqué. Es un sistema. Tengo todo organizado por niveles. Dejé de armar clases a las 11 de la noche.',
  name: 'Luciana R.',
  role: 'Profesora de Yoga Terapéutico',
  city: 'Mendoza',
  initial: 'LR',
  color: 'bg-emerald-500'
}, {
  quote: 'Los bonos solos valen el precio. Las meditaciones guiadas las uso TODAS las semanas. Encima las variantes me dieron ideas que ya implementé.',
  name: 'Sofía D.',
  role: 'Instructora de Yoga Restaurativo',
  city: 'Rosario',
  initial: 'SD',
  color: 'bg-indigo-500'
}, {
  quote: 'Me lo recomendó una colega del estudio. Lo descargué un viernes a la noche y el sábado ya tenía la primera clase armada para mis alumnos. Acceso inmediato real.',
  name: 'Javier P.',
  role: 'Profesor de Ashtanga Yoga',
  city: 'La Plata',
  initial: 'JP',
  color: 'bg-brand-600'
}];
export function Testimonials() {
  return <section className="py-24 lg:py-32 bg-white" data-id="element-216">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-217">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-218">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-brand-50 text-brand-700 font-medium text-xs uppercase tracking-widest mb-6 border border-brand-100/50" data-id="element-219">
            Voces reales
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-medium text-ink-900 mb-6 leading-tight tracking-tight" data-id="element-220">
            Lo que dicen{' '}
            <span className="text-brand-600 italic" data-id="element-221">+1.800 profesores</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-222">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className={`bg-[#FAF8F5] rounded-[2rem] p-8 hover:shadow-md transition-all duration-300 relative ${i === 0 ? 'lg:col-span-1' : ''} ${i === 3 ? 'lg:col-start-1' : ''}`} data-id="element-223">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-brand-100" fill="currentColor" data-id="element-224" />
              <div className="flex text-accent-400 mb-6" data-id="element-225">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-226" />)}
              </div>
              <p className="text-ink-700 leading-relaxed mb-8 text-[15px] font-light" data-id="element-227">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4 pt-6 border-t border-ink-100/50" data-id="element-228">
                <div className={`${t.color} w-12 h-12 rounded-full flex items-center justify-center text-white font-medium text-sm shadow-sm`} data-id="element-229">
                  {t.initial}
                </div>
                <div data-id="element-230">
                  <div className="font-medium text-ink-900 text-sm" data-id="element-231">
                    {t.name}
                  </div>
                  <div className="text-ink-500 text-xs font-light mt-0.5" data-id="element-232">
                    {t.role} · 📍 {t.city}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}